export default __webpack_public_path__ + "static/media/slack.847eae7b.svg";